"use client";

import type { UseOpenApiInfiniteQueryOptions } from "@packages/sdk";
import {
  getRequestNextPageParam,
  keyCommunitiesAdminUsers,
  useOpenApiInfiniteQuery,
} from "@packages/sdk";

const urlBackendPath = "/communities/{community_id}/admin/users" as const;

export const useRequestCommunitiesAdminUsers = ({
  params,
  ...props
}: Partial<UseOpenApiInfiniteQueryOptions<typeof urlBackendPath>>) => {
  return useOpenApiInfiniteQuery({
    ...props,
    getNextPageParam: (lastPage, _allPages, lastPageParam: number) =>
      getRequestNextPageParam({
        total: lastPage.total,
        lastPageParam,
        pageSize: 50,
      }),
    initialPageParam: 0,
    params,
    queryKey: keyCommunitiesAdminUsers({
      id: params?.path?.community_id,
      ...params?.query,
    }),
    urlBackendPath,
  });
};
